import { useTribalContext } from '@/context/tribal';
import {
  Text,
  TokenTextAppearance,
  styled,
} from '@volkswagen-onehub/components-core';
import { useState } from 'react';
import Accordion from '@/modules/components/Accordion/Accordion';
import { getTerms } from '@/modules/pages/Terms';
import { SectionNames } from '@/analytics/sectionNames';
import useGlobalStore, {
  GlobalStoreStateConfiguration,
} from '@/stores/globalStore';
import {
  handleAccordionClose,
  handleAccordionOpen,
} from '@/analytics/eventHelpers/accordion';
import { tokens } from '@/modules/utils/themeUtils';

const TermsWrapper = styled.div(
  ({ theme }) => `
  color: ${theme.colors.content.tertiary};
`);

const AccordionWrapper = styled.div`
  #understanding-pb_head {
    background-color: ${tokens.globalColors.vLightGrey};
  }
`;

interface AccordionUnderstandingPbProps {
  sectionName?: SectionNames;
  configurations?: GlobalStoreStateConfiguration[];
}

const AccordionUnderstandingPb = (props: AccordionUnderstandingPbProps) => {
  const { sectionName, configurations } = props;
  const { contentManager, analyticsBuilder, analyticsManager } =
    useTribalContext();
  const { retailers } = useGlobalStore((state) => state.app);
  const [open, setOpen] = useState(false);

  const accordionTitle = contentManager.get('understanding-pb-title');

  const analyticsCommonFields = {
    sectionName,
    analyticsManager,
    analyticsBuilder,
    retailers,
    configurations,
  };

  const onToggle = () => {
    setOpen(!open);

    if (!open) {
      handleAccordionOpen(analyticsCommonFields, {
        groupItemName: accordionTitle,
        groupItemState: 'open',
      });
    } else {
      handleAccordionClose(analyticsCommonFields, {
        groupItemName: accordionTitle,
        groupItemState: 'closed',
      });
    }
  };

  return (
    <AccordionWrapper>
      <Accordion
        id="understanding-pb"
        title={
          <Text appearance={TokenTextAppearance.bigcopy200} bold>
            {accordionTitle}
          </Text>
        }
        isOpen={open}
        onToggle={onToggle}
      >
        <TermsWrapper>
          {getTerms({
            text: contentManager.get('understanding-pb-text'),
            inherit: true,
          })}
          {getTerms({
            text: contentManager.get('understanding-pb-section-2'),
            inherit: true,
          })}
          {getTerms({
            text: contentManager.get('understanding-pb-section-3'),
            inherit: true,
          })}
          {getTerms({
            text: contentManager.get('understanding-pb-section-4'),
            inherit: true,
          })}
          {getTerms({
            text: contentManager.get('understanding-pb-section-5'),
            inherit: true,
          })}
          {getTerms({
            text: contentManager.get('understanding-pb-section-6'),
            inherit: true,
          })}
          {getTerms({
            text: contentManager.get('understanding-pb-section-7'),
            inherit: true,
          })}
          {getTerms({
            text: contentManager.get('understanding-pb-section-8'),
            margin: false,
            inherit: true,
          })}
        </TermsWrapper>
      </Accordion>
    </AccordionWrapper>
  );
};

export default AccordionUnderstandingPb;
